import React from "react";
import BatchesContainer from "../../modules/OrganizationBatches/containers/BatchesContainer/BatchesContainer";

const Batches = () => {
  return <BatchesContainer />;
};

export default Batches;
